<template>
    <ion-page>
        <ion-header class="ion-no-border">
            <ion-toolbar color="custom-white">
                <ion-buttons slot="start">
                    <ion-button color="primary" @click="handleBackButton()">
                        <mdicon name="arrow-left"></mdicon>
                    </ion-button>
                </ion-buttons>

                <ion-title>
                    <span>Nieuwe meting</span>
                </ion-title>

                <ion-buttons slot="end" v-if="selected_measurement_type">
                    <ion-button color="primary" @click="openPopover">
                        <mdicon name="dots-vertical"></mdicon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>

        <ion-popover ref="popover" :event="popoverEvent">
            <ion-list>
                <ion-item @click="confirm(true)">
                    <mdicon class="text-success" slot="start" name="content-save-check-outline"></mdicon>
                    <ion-label color="success">Voltooid</ion-label>
                </ion-item>
                <ion-item @click="confirm(false)">
                    <mdicon class="text-medium" slot="start" name="content-save-settings-outline"></mdicon>
                    <ion-label color="medium">Concept</ion-label>
                </ion-item>
            </ion-list>
        </ion-popover>

        <ion-content color="light">
            <template v-if="!loading">

                <list :dont_show_recently_searched="true" :inset="true" v-if="!selected_measurement_type" :show_search="true" :items="getMeasurementTypes" @open="setMeasurementType" @new="newComponent" :max_items="20" :item_size="50" :no_created_at="true" last_searched_section="components" :parent_uuid="parent_uuid" :loading="loading">
                    <template v-slot:no-data>
                        <p class="no-data-title">Geen metingtypen gevonden</p>
                        <p class="no-data-subtitle">
                            Staat het metingtype dat je zoekt niet in de lijst? Vraag de beheerder om deze toe te
                            voegen.
                        </p>
                    </template>
                </list>


                <template v-if="selected_measurement_type">
                    <ion-button class="mt-4" size="small" @click="deselectMeasurementType()" fill="clear" color="primary">
                        <mdicon name="chevron-left"></mdicon>
                        Kies een ander metingtype
                    </ion-button>

                    <ion-list :inset="true">
                        <select-row v-if="!this.$store.getters.getInspectionId" label="Inspectie" v-model:value="measurement.inspection_id" :items="inspections" field_name="name" field_value="id" />

                        <select-row-tree v-if="!hide_location_item_row" :key="measurement.inspection_id" :disabled="!measurement.inspection_id" label="Bouwdeel" v-model:value="current_location_item_uuid" field_name="uuid" :inspection_id="measurement.inspection_id" />

                        <SelectLocationItemComponent v-if="!hide_location_item_component_row" :auto_select="true" :disabled="!current_location_item_uuid || disabled" :location_item_uuid="current_location_item_uuid" v-model:value="measurement.location_item_component_uuid" />
                    </ion-list>

                    <image-array v-if="selected_measurement_type && selected_measurement_type.has_image" class="mt-3" :imageable_uuid="measurement.uuid" :disabled="!measurement.location_item_component_uuid" ref="image-array"></image-array>

                    <ion-list :inset="true">
                        <ion-item lines="inset">
                            <ion-label position="stacked">Meting omschrijving</ion-label>
                            <ion-input v-model="measurement.name" placeholder="Naam meting"></ion-input>
                        </ion-item>

                    </ion-list>


                    <div class="title-card sticky-title" v-if="measurement?.rules?.fields?.length > 0 && $store.getters.getInspectionMethodCode == 'IB22'">
                        <ion-label slot=" start"><strong>Resultaat meting</strong></ion-label>
                        <ion-chip slot="end" :color="getMeasurementResult.color">
                            {{ getMeasurementResult ?
                                getMeasurementResult.label.toLowerCase() : "geen resultaat"
                            }}
                        </ion-chip>
                    </div>

                    <Calculator v-if="selected_measurement_type" :rules="measurement.rules" :measurement_type_id="measurement.measurement_type_id" :inspection_id="measurement.inspection_id">
                    </Calculator>

                    <ion-list :inset="true">
                        <Remark v-if="selected_measurement_type" @savePrivateRemark="savePrivateRemark" :disabled="!measurement.location_item_component_uuid" label="Toelichting" v-model:value="measurement.remark" :description_value="measurement.remark_description" @updateDescription="measurement.remark_description = $event" field_name="name" @autoClassify="setClassificationResult" />

                    </ion-list>

                    <transition name="fade">
                        <ClassificationComponent v-if="measurement.is_defect && selected_measurement_type" :model="measurement" :preset_is_defect="true" @change="setClassificationResult">
                        </ClassificationComponent>
                    </transition>



                </template>
            </template>

            <loading v-if="loading"></loading>

        </ion-content>
        <ion-footer class="mb-2 ion-no-border" v-if="selected_measurement_type">
            <ion-toolbar color="custom-white">
                <ion-buttons slot="start">
                    <ion-button color="medium" @click="handleBackButton()">
                        <mdicon class="icon" slot="start" name="close" />
                        Annuleren
                    </ion-button>
                </ion-buttons>
                <ion-buttons slot="end">
                    <ion-button color="medium" @click="confirm(false)">
                        <mdicon class="icon" slot="start" name="content-save-outline" />
                        Concept
                    </ion-button>
                    <ion-button color="primary" @click="confirm(true)">
                        <mdicon class="icon" slot="start" name="content-save-check-outline" />
                        Voltooid
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>

        </ion-footer>
    </ion-page>
</template>
<script>
import {
    IonContent, IonIcon, IonHeader, IonPopover, alertController
} from '@ionic/vue';
import { add, list, albumsOutline, save, close, chevronBack, shieldCheckmark, calculator } from 'ionicons/icons';
import uuid from '@/plugins/uuid';
import { db } from '@/services/db'
import Calculator from './include/Calculator.vue';
import SelectRow from '@/components/SelectRow.vue';
import SelectRowTree from '@/components/SelectRowTree.vue';
import ImageArray from '@/components/ImageArray.vue';
import Remark from '@/components/Remark.vue';
import measurement_validation from '@/services/measurement_validation';
import SelectLocationItemComponent from '@/components/SelectLocationItemComponent.vue';
import patch_post_parser from '@/services/patch_post_parser';
import ClassificationComponent from '@/components/ClassificationComponent.vue';
import measurement_calculator from "@/services/measurement_calculator";
import convert from "@/services/convert";
import Loading from '@/components/Loading.vue';
import List from '@/components/List.vue';

export default {
    name: "create-measurement",
    props: ['fields', 'location_item_component_uuid', 'location_item_uuid', 'inspection_id'],
    components: {
        SelectLocationItemComponent,
        IonContent,
        IonIcon,
        IonHeader,
        Calculator,
        IonPopover,
        SelectRow,
        ClassificationComponent,
        ImageArray,
        Remark,
        SelectRowTree,
        Loading,
        List,
    },
    data() {
        return {
            shieldCheckmark,
            add,
            list,
            albumsOutline,
            save,
            close,
            chevronBack,
            selected_measurement_type: null,
            measurement_types: [],
            measurement: {
                uuid: uuid(),
                name: "",
                location_item_component_uuid: null,
                inspection_id: this.$store.getters.getInspectionId,
                measurement_type_id: null,
                rules: [],
                description: "",
                completed: false,
                measurement_instrument_ids: [],
                is_defect: false,
                remark: "",
            },
            loading: true,
            location_item_components: [],
            location_item_component: {
                name: "",
            },
            location_items: [],
            current_location_item_id: null,
            inspections: [],
            current_location_item_uuid: null,
            inspection: null,
            disabled: false,
            measurement_instrument_types: [],
            measurement_instruments: [],
            measurement_type_revisions: [],
            popoverEvent: null,
            hide_inspection_row: false,
            hide_location_item_row: false,
            hide_location_item_component_row: false,
        }
    },
    ionViewWillEnter() {
        this.setup()
    },
    ionViewWillLeave() {
        // Cleanup ImageArray component when page is cached
        if (this.$refs.imageArray) {
            if (this.$refs.imageArray.stopPolling) {
                this.$refs.imageArray.stopPolling();
            }

            // CRITICAL: Remove event listener that keeps component in memory
            if (this.$refs.imageArray.visibilityHandler) {
                document.removeEventListener('visibilitychange', this.$refs.imageArray.visibilityHandler);
            }

            // LazyImage components handle their own memory cleanup
            // Note: Don't clear images_array here - component will be properly destroyed on save/delete
        }
    },
    methods: {
        async handleBackButton() {
            // Delete any images that were added when canceling
            db.images.where({ imageable_uuid: this.measurement.uuid }).toArray().then(images => {
                for (let image of images) {
                    db.images.delete(image.uuid);
                }
            });
            this.$router.back();
        },
        setClassificationResult(result) {
            // Only update classification if result is provided and not undefined
            // This prevents clearing classification when:
            // 1. Selecting remarks without classification
            // 2. During component initialization
            if (result !== undefined) {
                this.measurement.classification = result;

                // for now we also set danger_aspect_id, error_indication_id, error_classification_id and repair_period_id separately
                // this is because the old way of setting the classification is still in use
                this.measurement.danger_aspect_id = result?.danger_aspect_id;
                this.measurement.error_indication_id = result?.error_indication_id;
                this.measurement.error_classification_id = result?.error_classification_id;
                this.measurement.repair_period_id = result?.repair_period_id;
            }
        },
        async openPopover(ev) {
            this.popoverEvent = ev;
            await this.$refs.popover.$el.present();
        },
        updateDescription(description) {
            this.measurement.remark_description = description
        },
        setIds(ids) {
            this.measurement.measurement_instrument_ids = ids
        },
        setMeasurementTypeId(event) {
            this.measurement.measurement_type_id = event.detail.value
        },
        savePrivateRemark(save) {
            this.measurement.save_private_remark = save
        },
        addImage(image) {
            this.images.push(image)
        },
        compareWith(o1, o2) {
            return o1 && o2 ? o1.id === o2.id : o1 === o2;
        },
        setMeasurement(measurement) {
            this.measurement = measurement
        },
        async setup() {
            this.loading = true
            this.hide_inspection_row = true
            this.measurement.inspection_id = this.$store.getters.getInspectionId

            if (this.$route.query.location_item_uuid) {
                this.current_location_item_uuid = this.$route.query.location_item_uuid
                this.hide_location_item_row = true
            }

            if (this.$route.query.location_item_component_uuid) {
                this.measurement.location_item_component_uuid = this.$route.query.location_item_component_uuid
                this.hide_location_item_component_row = true
            }

            this.measurement_types = await db.measurement_types.toArray().then((measurement_types) => {
                return measurement_types.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }))
            })

            this.measurement_instrument_types = await db.measurement_instrument_types.toArray()

            this.measurement_types = await db.measurement_types.toArray().then((measurement_types) => {
                return measurement_types.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }))
            })

            const inspection = await db.inspections.where({ id: parseInt(this.$store.getters.getInspectionId) }).first();
            const measurement_type_revision_ids = inspection.measurement_type_revisions.map(revision => revision.id);
            this.measurement_type_revisions = await db.measurement_type_revisions.where('id').anyOf(measurement_type_revision_ids).toArray();

            this.location_item_components = await db.location_item_components.toArray()
            this.location_item_component = this.location_item_components.find((item) => {
                return item.uuid == this.measurement.location_item_component_uuid
            })
            this.location_items = await db.location_items.toArray()
            this.inspections = await db.inspections.toArray()

            this.refreshLocationItems()

            // if we have a temp save, we should load this
            if (this.$store.getters.getTempSave) {
                this.observation = this.$store.getters.getTempSave
                // we should remove the temp save
                this.$store.dispatch('setTempSave', null)
            }

            setTimeout(() => {
                this.loading = false
            }, 500)
        },
        setImages(images) {
            this.images = images
        },
        async confirm(complete_measurement) {
            if (!measurement_validation.validate(this.measurement, true, !complete_measurement, this.$store.getters.getInspectionMethodCode)) {
                return
            }

            this.$refs.popover.$el.dismiss();

            this.measurement.completed = complete_measurement
            let clone_measurement = JSON.parse(JSON.stringify(this.measurement))
            let parsed_measurement = patch_post_parser('measurements', clone_measurement);
            parsed_measurement.not_synced = true;

            // if parsed_measurement.rules.result is object, we rewrite it to value
            if (typeof parsed_measurement.rules.result === "object") {
                parsed_measurement.rules.result = parsed_measurement.rules.result.value
            }

            // add to jobs
            let url = '/inspections/' + this.measurement.inspection_id + '/location-item-components/' + this.measurement.location_item_component_uuid + '/measurements';
            await this.$requests.post('measurements', url, parsed_measurement)

            await this.createImages()

            // Invalidate component count cache
            this.$store.dispatch('setComponentCountKey');

            this.$router.back()

        },
        async createImages() {
            let images = await db.images.where({ imageable_uuid: this.measurement.uuid }).toArray()

            for (let image of images) {
                // Check if there's already a job for this image
                // This prevents duplicate jobs if the image was edited before saving
                const allJobs = await db.jobs.toArray();
                const existingJob = allJobs.find(job => 
                    (job.payload && job.payload.image_uuid === image.uuid) ||
                    (job.payload && job.payload.existing_image_uuid === image.uuid)
                );
                
                if (existingJob) {
                    console.log(`Job already exists for image ${image.uuid} (type: ${existingJob.type}), skipping job creation`);
                    continue;
                }
                
                // Check if image needs compression
                if (!image.compressed) {
                    try {
                        console.log(`Compressing uncompressed image ${image.uuid} before upload`);

                        // Compress the image (1MB target, quality 0.75)
                        const compressedBase64 = await convert.compress(
                            image.base64,
                            1, // maxSizeMB: 1MB (changed from 2MB)
                            1920, // targetWidth: max dimension
                            0.75, // minQuality: JPEG quality (changed from 0.9)
                            false, // addLabel: no label
                            this.$store.getters.checkSetting("crop_to_square"),
                            this.$store.getters.getImageTimestamp,
                            this.$store.getters.getImageInspectorName,
                            this.$store.getters.getUser.name
                        );

                        // Update the image in database with compressed version
                        await db.images.update(image.uuid, {
                            base64: compressedBase64,
                            compressed: true,
                            updated_at: new Date().toISOString()
                        });

                        // Update local reference
                        image.base64 = compressedBase64;
                        image.compressed = true;
                    } catch (error) {
                        console.error(`Failed to compress image ${image.uuid}:`, error);
                        // If compression fails, we'll still upload the original
                        // but log the error for debugging
                    }
                }

                // Use the new S3 upload flow
                const jobUuid = uuid();
                await db.jobs.add({
                    uuid: jobUuid,
                    type: "image-s3-upload",
                    module: "images",
                    url: null,
                    attempt: 0,
                    payload: {
                        uuid: jobUuid,
                        image_uuid: image.uuid,
                        imageable_uuid: this.measurement.uuid,
                        entity_type: 'measurement'
                    },
                    created_at: new Date().toISOString(),
                });
            }
        },
        refreshLocationItems() {
            db.inspections.where({ id: this.measurement.inspection_id }).first().then(inspection => {
                db.location_items.where({ location_id: inspection.location_id }).toArray().then(location_items => {
                    this.location_items = location_items
                })
            })
        },
        refreshLocationItemComponents() {
            if (this.current_location_item_uuid) {
                db.location_item_components.where({ location_item_uuid: this.current_location_item_uuid }).toArray().then(location_item_components => {
                    this.location_item_components = location_item_components
                })
            }
        },
        async setMeasurementType(measurement_type) {
            this.selected_measurement_type = measurement_type
            this.measurement.measurement_type_id = measurement_type?.id
            this.measurement.description = measurement_type?.description
            this.measurement.name = measurement_type?.name

            // get correct measurement type revision
            const inspection = await db.inspections.get(this.$store.getters.getInspectionId);

            let measurement_type_revisions = await db.measurement_type_revisions.toArray();
            measurement_type_revisions = measurement_type_revisions.filter((mtr) =>
                inspection.measurement_type_revisions.some((imtr) => imtr.id === mtr.id)
            );

            const measurement_type_revision = measurement_type_revisions.find(
                (mtr) => mtr.measurement_type_id === measurement_type?.id
            );

            if (!measurement_type_revision) {
                console.error("No measurement type revision found for measurement type", measurement_type?.id);
                return;
            }
            // end get correct measurement type revision

            this.measurement.rules = measurement_type_revision.rules;
            this.measurement.rules.revision_id = measurement_type_revision.id;
        },
        deselectMeasurementType() {
            this.selected_measurement_type = null

            this.measurement = {
                uuid: uuid(),
                name: "",
                location_item_component_uuid: null,
                inspection_id: this.$store.getters.getInspectionId,
                measurement_type_id: null,
                rules: [],
                description: "",
                completed: false,
                measurement_instrument_ids: [],
                is_defect: false,
                remark: "",
            }
        },
    },
    computed: {
        getMeasurementInstruments() {
            return this.measurement_instruments
        },
        getLocationItems() {
            return this.location_items
        },
        getLocationItemComponents() {
            return this.location_item_components
        },
        getMeasurementTypes() {
            return this.measurement_types
        },
        getMeasurementResult() {
            if (typeof this.measurement.rules.result === "object") {
                return measurement_calculator.output_values.find(value => value.value == this.measurement.rules.result.value)
            }

            return measurement_calculator.output_values.find(value => value.value == this.measurement.rules.result)
        }
    },
    watch: {
        $route(to, from) {
            if (to.name == 'image-editor') {
                this.$store.dispatch('setTempSave', this.measurement)
            }
        },
        "measurement.rules.fields": {
            handler() {
                if (this.fields && this.measurement.rules && this.measurement.rules.fields) {
                    this.measurement.rules.fields.forEach(field => {
                        let current_field = this.fields.find(f => f.uuid == field.uuid)
                        if (current_field) {
                            field.value = current_field.value
                        }
                    })
                }
            },
            immediate: true,
        },
        current_location_item_uuid: {
            handler() {
                this.refreshLocationItemComponents()
            }
        },
        "measurement.inspection_id": {
            handler() {
                this.refreshLocationItems()
            }
        },
        "measurement.rules.result": {
            handler() {
                if (this.measurement.rules.result == 'incorrect') {
                    this.measurement.is_defect = true
                } else {
                    this.measurement.is_defect = false
                }
            }
        },
    },
    async beforeRouteLeave(_to, _from, next) {
        // Always allow navigation
        next();
    },

}
</script>
<style lang="">

</style>
